module.exports = __webpack_public_path__ + "img/logoAIPassIntelite-preto.c4177a26.png";